import { action } from 'typesafe-actions';
import { CentrosDistribuicaoTypes, ICentrosDistribuicao } from './types';

export const loadRequest = () => action(CentrosDistribuicaoTypes.LOAD_REQUEST, {});
export const loadSuccess = (data: ICentrosDistribuicao[]) =>
  action(CentrosDistribuicaoTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(CentrosDistribuicaoTypes.LOAD_FAILURE, {});
